import { z } from 'zod';

export const SEVERITY = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug',
} as const;

export const severitySchema = z.enum(SEVERITY);

export type Severity = z.infer<typeof severitySchema>;

export type AttributeValue = string | number | boolean | undefined;

export type Attributes = Record<string, AttributeValue>;

export interface LogRecord {
  severity: Severity;
  body: string;
  scope: string;
  attributes: Attributes;
  timestamp: number;
}

export interface LogInput {
  error?: unknown;
  attributes?: Attributes;
}

export interface Logger {
  readonly scope: string;
  error(message: string, input?: LogInput): void;
  warn(message: string, input?: LogInput): void;
  info(message: string, input?: LogInput): void;
  debug(message: string, input?: LogInput): void;
  /**
   * Returns a new logger that auto-attaches the given attributes to every
   * emit. Use it to carry context across several related logs. The scope is
   * inherited; for a different scope, call `getLogger({ scope })`.
   */
  child(boundAttributes: Attributes): Logger;
}

export interface LoggerAdapter {
  emit(record: LogRecord): void;
}
